import Phone from "../shared/phone";
import React from "react";

const Phones = ({ entity }) => {
  if (entity.siteOptions.entityType === 2) {
    return (
      <Phone number={entity.primaryPhone} prefix="Tel" classes="line-item" />
    );
  }
  return (
    <div>
      <Phone
        number={entity.mobilePhone}
        prefix="M"
        classes={`line-item ${
          entity.mobilePhone !== entity.workPhone ? "spacing-right" : ""
        }`}
      />
      {entity.mobilePhone !== entity.workPhone ? (
        <Phone number={entity.workPhone} prefix="O" classes="line-item" />
      ) : (
        ""
      )}
    </div>
  );
};

export default Phones;



// WEBPACK FOOTER //
// ./src/components/contact/phones.js